import React from "react";
import { SELECT_BASE, LABEL_TEXT } from "../styles/classNames";

/**
 * Универсальный компонент для select полей
 */
export function FormSelect({ label, value, onChange, options, placeholder, disabled = false }) {
  return (
    <label className="block">
      <div className={LABEL_TEXT}>{label}</div>
      <select value={value} onChange={onChange} className={SELECT_BASE} disabled={disabled}>
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option) => (
          <option key={option.value || option} value={option.value || option}>
            {option.label || option}
          </option>
        ))}
      </select>
    </label>
  );
}
